@import 'styles/variables';
@import 'styles/mixins.scss';

.error {
  color: $red-50;
  font-size: 12px;
}

.errorWrap {
  margin-top: 20px;
}

.title {
  margin-bottom: 36px;
  margin-top: 120px;
}

.largerLeftContent {
  &.isBlaze {
    margin-top: -5px;
    justify-content: center;
  }
}
